import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import ChevronDownIcon from '../../../../svg/nav/chevronDownIcon';
import Async from '../../../Async';

/* Style */
import t from '../../../../css/global.module.css';
import s from './rakutenSisters.module.css';


const RakutenSisters = ({ className, defaultVisible }) => (
  <Tooltip
    overlay={() => (
      <Async
        promise={
            import(
              /* webpackChunkName: "RakutenSistersTooltip" */
              /* webpackMode: "lazy" */
              // eslint-disable-next-line function-paren-newline
              './components/RakutenSistersTooltip')
        }
      />
    )}
    overlayClassName={`${s.rakutenSisters}`}
    mouseEnterDelay={0.2}
    getTooltipContainer={trigger => trigger}
    placement="bottom"
    defaultVisible={defaultVisible}
  >
    <div className={`${s.container} ${className} ${t['helper_hide-BelowTablet']}`}>
      <span className={s.icon}>
        <ChevronDownIcon />
      </span>
    </div>
  </Tooltip>
);

RakutenSisters.defaultProps = {
  defaultVisible: false,
  className: '',
};

RakutenSisters.propTypes = {
  defaultVisible: PropTypes.bool,
  className: PropTypes.string,
};

export default RakutenSisters;
